export default {"src":"/_next/static/media/logo-footer.a3c03405.svg","height":182,"width":526,"blurWidth":0,"blurHeight":0};